import { onDemand } from "@/utils/onDemand";

export default ({ app }, inject) => {
  // const loader1 = new onDemand(
  //   "https://code.jquery.com/jquery-3.6.0.slim.min.js",
  //   false
  // );
  // const loader2 = new onDemand("https://js.hsforms.net/forms/v2.js", false);

  // inject("hubspot", {
  //   forms(region, portalId, formId, target, onFormSubmit, onFormSubmitted) {
  //     loader1.load();
  //     loader2.load(() => {
  //       new window.hbspt.forms.create({
  //         region,
  //         portalId,
  //         formId,
  //         target,
  //         onFormSubmit,
  //         onFormSubmitted,
  //       });
  //     });
  //   },
  // });
};
